var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.18867V4.08005C8.5 4.47209 8.5 4.6681 8.58175 4.81784C8.65365 4.94956 8.76839 5.05664 8.90951 5.12375C9.06994 5.20005 9.27996 5.20005 9.7 5.20005H12.7979M10 8.7H4M10 11.5H4M5.5 5.9H4M8.5 1H4.6C3.33988 1 2.70982 1 2.22852 1.22889C1.80516 1.43022 1.46095 1.75148 1.24524 2.14662C1 2.59583 1 3.18389 1 4.36V11.64C1 12.8161 1 13.4042 1.24524 13.8534C1.46095 14.2485 1.80516 14.5698 2.22852 14.7711C2.70982 15 3.33988 15 4.6 15H9.4C10.6601 15 11.2902 15 11.7715 14.7711C12.1948 14.5698 12.539 14.2485 12.7548 13.8534C13 13.4042 13 12.8161 13 11.64V5.2L8.5 1Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.3861e3350a5deb4aa4cd153841c1bd2c.svg";
export { ForwardRef as ReactComponent };